/* eslint-disable css-modules/no-unused-class  */
import { Divider, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './overallAchievements.module.scss';

const OverallAchievements: FC<OverallAchievementsProps> = (props: OverallAchievementsProps) => {
    const { strongCategories, fairCategories, poorCategories, assessmentsTakenNumber, overallRating } = props;

    const strongEmptyText = translate('strongEmptyText');
    const poorEmptyText = translate('poorEmptyText');
    const fairEmptyText = translate('fairEmptyText');

    return (
        <div className={styles['overall-wrapper']}>
            <div className={styles['left-wrapper']}>
                <div className={styles['left-wrapper-box-divider']}>
                    <div className={styles['assessment-taken-wrapper']}>
                        <div className={styles['assessment-taken']}>{translate('AssessmentsTaken')}</div>
                        <div className={styles['assessment-taken-count']}>{assessmentsTakenNumber}</div>
                    </div>
                    <div className={styles['overall-rating-wrapper']}>
                        <div className={styles['overall-rating']}>{translate('OverallRating')}</div>
                        <div className={styles['overall-rating-count']}>{overallRating}%</div>
                    </div>
                </div>

                <Divider
                    orientation="vertical"
                    className={styles['assessment-divider']}
                    color="rgba(255, 255, 255, 0.2)"
                />
            </div>
            <div className={styles.right}>
                <div className={styles.performance}>{translate('PerformanceByCategory')}</div>
                <Divider
                    className={styles['performance-divider']}
                    orientation="horizontal"
                    color="rgba(255, 255, 255, 0.2)"
                />

                <div className={styles['performance-categories']}>
                    <div className={styles['strong-category']}>
                        <div className={styles['strong-title']}>{translate('Strong')}</div>
                        {strongCategories.length > 0 ? (
                            strongCategories.map((subtitle, index) => (
                                <div key={index} className={styles.subtitle} title={subtitle}>
                                    {subtitle}
                                </div>
                            ))
                        ) : (
                            <div className={styles['empty-state']}>
                                <Icon name="showThem" isPng />
                                <div className={styles['empty-state-text']}>{strongEmptyText}</div>
                            </div>
                        )}
                    </div>
                    <Divider
                        orientation="vertical"
                        className={styles['categories-divider']}
                        color="rgba(255, 255, 255, 0.2)"
                    />

                    <div className={styles['fair-category']}>
                        <div className={styles['fair-title']}>{translate('Fair')}</div>
                        {fairCategories.length > 0 ? (
                            fairCategories.map((subtitle, index) => (
                                <div key={index} className={styles.subtitle} title={subtitle}>
                                    {subtitle}
                                </div>
                            ))
                        ) : (
                            <div className={styles['empty-state']}>
                                <Icon name="clear" isPng />
                                <div className={styles['empty-state-text']}>{fairEmptyText}</div>
                            </div>
                        )}
                    </div>
                    <Divider
                        orientation="vertical"
                        className={styles['categories-divider']}
                        color="rgba(255, 255, 255, 0.15)"
                    />
                    <div className={styles['poor-category']}>
                        <div className={styles['poor-title']}>{translate('Poor')}</div>
                        {poorCategories.length > 0 ? (
                            poorCategories.map((subtitle, index) => (
                                <div key={index} className={styles.subtitle} title={subtitle}>
                                    {subtitle}
                                </div>
                            ))
                        ) : (
                            <div className={styles['empty-state']}>
                                <Icon name="stillGotThis" isPng />
                                <div className={styles['empty-state-text']}>{poorEmptyText}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface OverallAchievementsProps {
    strongCategories: string[];
    fairCategories: string[];
    poorCategories: string[];
    assessmentsTakenNumber: number;
    overallRating: number;
}

export default OverallAchievements;
